import {gql, useLazyQuery} from '@apollo/client';
import {useEffect, useState} from 'react';

/**
 * GraphQL query to fetch OpenAI enabled status from the server
 */
export const GET_OPENAI_STATUS = gql`
  query GetOpenAIStatus @skipAudit @engComponent(name: LLM) {
    currentTenant {
      id
      tenantAdminData {
        ... on TenantAdminDataNode {
          id
          llmFeaturesConfiguration {
            ... on LLMFeaturesConfigurationNode {
              isOpenAIEnabled
            }
          }
        }
      }
    }
  }
`;

/**
 * Hook to access OpenAI enabled status.
 *
 * @returns {boolean} Whether OpenAI is enabled on the tenant
 */
export function useOpenAIEnabled(): boolean {
  const [isOpenAIEnabled, setIsOpenAIEnabled] = useState<boolean>(false);
  const [getOpenAIStatus, {loading, data}] = useLazyQuery(GET_OPENAI_STATUS);

  useEffect(() => {
    getOpenAIStatus();
  }, [getOpenAIStatus]);

  useEffect(() => {
    if (
      !loading &&
      data?.currentTenant?.tenantAdminData?.llmFeaturesConfiguration?.isOpenAIEnabled !== undefined
    ) {
      setIsOpenAIEnabled(data.currentTenant.tenantAdminData.llmFeaturesConfiguration.isOpenAIEnabled);
    }
  }, [loading, data]);

  return isOpenAIEnabled;
}
